import { STORAGE_PAGINATION_KEY, } from '@wix/wixstores-client-core';
import { SPECS } from '../../constants';
var NavigationService = /** @class */ (function () {
    function NavigationService(_a) {
        var siteStore = _a.siteStore;
        this.siteStore = siteStore;
    }
    NavigationService.prototype.getContextualProductDescriptors = function () {
        var paginationMap = this.navigationContext.paginationMap;
        if (this.siteStore.isEditorMode() || !paginationMap.length) {
            return [];
        }
        return paginationMap.map(function (p) { return (typeof p !== 'string' ? p : { slug: p }); });
    };
    Object.defineProperty(NavigationService.prototype, "navigationContext", {
        get: function () {
            var context;
            try {
                var storage = this.siteStore.experiments.enabled(SPECS.SwitchLocalStorageToSessionStorageInGalleryNavigationToPP)
                    ? this.siteStore.storage.session
                    : this.siteStore.storage.local;
                context = JSON.parse(storage.getItem(STORAGE_PAGINATION_KEY));
            }
            catch (_a) {
                //
            }
            return context !== null && context !== void 0 ? context : { pageId: undefined, paginationMap: [], pagePath: [] };
        },
        enumerable: false,
        configurable: true
    });
    return NavigationService;
}());
export { NavigationService };
//# sourceMappingURL=NavigationService.js.map